module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/classic_2-392fcafea0b5ae901e21c59e4e865bd9.png";